import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pillarArticles } from '@/mocks/articles';

const resourceItems = [
  { key: 'reviews', slug: 'usfans-review' },
  { key: 'shipping', slug: 'usfans-shipping-cost' },
  { key: 'coupons', slug: 'usfans-coupon' },
  { key: 'warehouse', slug: 'usfans-warehouse' },
  { key: 'legit', slug: 'usfans-legit' },
];

export default function ResourcesSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {t('about.title')}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              {t('about.p1')}
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              {t('about.p2')}
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {resourceItems.map((item, idx) => {
              const article = pillarArticles.find((a) => a.slug === item.slug);
              return (
                <Link
                  key={item.key}
                  to={`/article/${item.slug}`}
                  className={`group overflow-hidden rounded-lg border border-background-200 bg-white transition-colors hover:border-primary-300 ${
                    idx === 4 ? 'sm:col-span-2' : ''
                  }`}
                >
                  <div className="h-32 w-full overflow-hidden md:h-36">
                    <img
                      src={article?.image}
                      alt={t(`resources.${item.key}.title`)}
                      title={`${t(`resources.${item.key}.title`)} — USFans Spreadsheet`}
                      className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5">
                    <h3 className="text-sm font-bold text-foreground-950 md:text-base">
                      {t(`resources.${item.key}.title`)}
                    </h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">
                      {t(`resources.${item.key}.text`)}
                    </p>
                    <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-primary-700">
                      {t('category.visit')}
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-6 rounded-lg bg-secondary-100 p-6 md:p-8 lg:flex-row">
          <div className="text-center lg:text-left">
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              {t('guide.title')}
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">{t('guide.text')}</p>
          </div>
          <Link
            to="/usfans-spreadsheet-guide"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            {t('guide.cta')}
          </Link>
        </div>
      </div>
    </section>
  );
}